import Grid from "@Components/Grid";
import Paper from "@Components/Paper";
import { renderFieldData } from "@Components/FieldData/RenderFieldData";
import { Collateral as CollateralType, CollateralTypes } from "@Types/deal";

type CollateralProps = {
  collateral: CollateralType;
  type: CollateralTypes;
};

const Collateral = ({ collateral, type }: CollateralProps) => {
  return (
    <Paper
      title={"Collateral"}
      style={{ height: "100%", boxSizing: "border-box" }}
    >
      <Grid container xs={12}>
        <Grid xs={12}>{renderFieldData("VIN", collateral?.VIN ?? "-")}</Grid>
        <Grid xs={12}>
          {renderFieldData("Year", collateral?.year?.toString() ?? "-")}
        </Grid>
        <Grid xs={12}>{renderFieldData("Make", collateral?.make ?? "-")}</Grid>
        <Grid xs={12}>
          {renderFieldData("Model", collateral?.model ?? "-")}
        </Grid>
        <Grid xs={12}>{renderFieldData("Collateral Type", type)}</Grid>
      </Grid>
    </Paper>
  );
};
export default Collateral;
